import React from 'react'

export function WakaTimeEmbedLanguages () {
  return (
    <embed src='https://wakatime.com/share/@ceddy/a6365e81-b182-4a0a-86b8-59e3a25b2760.svg' />
  )
}

export default WakaTimeEmbedLanguages
